import classNames from 'classnames';
import { ComponentPropsWithoutRef } from 'react';
import styles from './Medal.module.scss';

export type MedalProps = {
  value: number;
} & ComponentPropsWithoutRef<'div'>;
export const Medal = ({ className, value, ...props }: MedalProps) => (
  <div
    className={classNames(
      styles.root,
      styles[`no${value}`],
      {
        [styles.won]: value <= 3,
      },
      className
    )}
    {...props}>
    {value}
  </div>
);
